import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Add = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Add' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,22 L12,2 M2,12 L22,12' />
  </StyledIcon>
);
